import React from 'react';

/** Kleine „denkt nach“-Animation neben Ergebnis-Feldern */
export function CallOutcomeThinking({ label = 'Ergebnis wird erkannt…' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 12px',
        borderRadius: 10,
        background: 'linear-gradient(90deg, rgba(117,118,201,0.08), rgba(29,190,116,0.12), rgba(117,118,201,0.08))',
        backgroundSize: '200% 100%',
        animation: 'crmOutcomeThinkBg 1.4s ease-in-out infinite',
        border: '1px solid rgba(117,118,201,0.25)',
        marginBottom: 10,
      }}
    >
      <style>{`
        @keyframes crmOutcomeThinkBg {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes crmOutcomeDot {
          0%, 80%, 100% { opacity: 0.25; transform: scale(0.85); }
          40% { opacity: 1; transform: scale(1); }
        }
      `}</style>
      <div style={{ display: 'flex', gap: 4 }}>
        {[0, 1, 2].map(i => (
          <span
            key={i}
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: '#7576c9',
              animation: `crmOutcomeDot 1s ease-in-out ${i * 0.15}s infinite`,
            }}
          />
        ))}
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, color: '#4f4b9e' }}>{label}</span>
    </div>
  );
}

/** Dezenter Hinweis direkt unter dem Ergebnis-Bereich */
export function CallOutcomeAmbiguousHint({ onDismiss }) {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        marginTop: 6,
        marginBottom: 4,
        padding: '5px 10px',
        borderRadius: 7,
        background: 'rgba(245,158,11,0.08)',
        border: '1px solid rgba(245,158,11,0.28)',
        fontSize: 11,
        lineHeight: 1.35,
        color: '#92400e',
      }}
    >
      <span>Ergebnis unklar – bitte manuell wählen.</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Schließen"
        style={{
          flexShrink: 0,
          width: 20,
          height: 20,
          border: 'none',
          borderRadius: 4,
          background: 'transparent',
          color: '#b45309',
          cursor: 'pointer',
          fontSize: 14,
          lineHeight: 1,
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
